import React, { useState, useEffect, useCallback, useRef } from 'react';
import { exponentialBackoff } from '../../../utils/index';

export default function Image({ src, alt, ...rest }) {
  const srcRef = useRef(src);
  const errorHandlerRef = useRef();
  const [isLoaded, setLoaded] = useState(false);

  const onNetworkChange = useCallback(() => {
    if (!isLoaded) {
      srcRef.current.src = `${src}?t=${Date.now()}`;
    }
  }, [isLoaded, src]);

  function onError() {
    if (!errorHandlerRef.current) {
      errorHandlerRef.current = exponentialBackoff(onNetworkChange, 15);
    }
    errorHandlerRef.current();
  }

  useEffect(() => {
    window.addEventListener('online', onNetworkChange);
    return () => {
      window.removeEventListener('online', onNetworkChange);
    };
  });

  if (src) {
    return (
      <img
        src={src}
        alt={alt}
        ref={srcRef}
        {...rest}
        onLoad={() => setLoaded(true)}
        onError={onError}
      />
    );
  }
  return <span>{alt}</span>;
}



// WEBPACK FOOTER //
// ./src/components/common/Image/Image.js